import type { IconProps } from '../types/IconProps.ts';
export const MapPinCheck: IconProps = {
    name: 'MapPinCheck',
    children: [
        `<path d="m12.04 21.93 5.79-9.64a6.8 6.8 0 1 0-11.66 0l5.79 9.64q.04.05.08 0" />`,
        `<path d="m10 9.5 1.56 1.46q.04.03.07 0L14 8" />`,
    ]
};